angular.module('shared').factory('FeatureNamesService', ["$rootScope", function($rootScope) {
  return {
    memberPortal: function(p = {}) {
      var defaultParams, gym, params;
      defaultParams = {
        divider: '/'
      };
      params = _.defaults(p, defaultParams);
      gym = $rootScope.gym;
      switch (false) {
        case !(gym.mobile_app_enabled && gym.member_portal_enabled):
          return `mobile app ${params.divider} member portal`;
        case !(gym.mobile_app_enabled && !gym.member_portal_enabled):
          return 'mobile app';
        default:
          return 'member portal';
      }
    }
  };
}]);
